import React from 'react';
import { DataList, Loader } from 'commons-ui';
import { useStyletron } from 'baseui';

import useDashboardActions from 'pages/userProfile/useUserProfileActions';
import { LIST_ENTITY_NAMES } from 'constant';

import useList from './useList';
import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';
import { columnConfigs } from './listConfig';
import DateRangeFilter from './DateRangeFilter';

const ListBulkReply: React.FC<{}> = () => {
	const { getBulkReplyData, handleFilterSubmit, forceUpdate, showLoader, setShowLoader } = useList();
	const { getActionHandler, getActionList } = useDashboardActions(makeActionHandler, makeActionList, {
		setShowLoader
	});
	const actions = getActionList();
	const [css] = useStyletron();

	return (
		<>
			{showLoader && <Loader />}
			<div
				className={css({
					height: '60px',
					display: 'flex',
					alignItems: 'center',
					backgroundColor: 'white',
					paddingLeft: '10px',
					paddingRight: '20px',
					borderTop: '1px solid rgb(242, 242, 242)',
					justifyContent: 'space-between',
					width: '100vw'
				})}>
				<DateRangeFilter onSubmit={handleFilterSubmit} />
			</div>
			<DataList
				fetchData={getBulkReplyData}
				columnConfigs={columnConfigs}
				getActionHandler={getActionHandler}
				actions={actions}
				globalForceUpdate={forceUpdate}
				entity={LIST_ENTITY_NAMES.BULK_REPLY}
				height='calc(100vh - 220px)'
			/>
		</>
	);
};

export default ListBulkReply;
